import { useState, type FunctionComponent } from "react";
import { ConversationHistorySider } from "~/components/conversations-history/conversation-history-sider";
import { MainContent } from "~/screens/home/main-content";
import { ReferenceDocuments } from "~/components/reference-docs/reference-documents";
import { Screen } from "~/screens/screen";

/**
 * Shared chat layout (history sider + chat + reference panel) used by both the new-chat Home
 * route and the /conversation/:id route. Session lifecycle is the caller's responsibility.
 */
export const ChatLayout: FunctionComponent = () => {
  const [isConversationHistorySiderCollapsed, setIsConversationHistorySiderCollapsed] = useState<boolean>(false);

  return (
    <Screen
      sider={
        <ConversationHistorySider
          className="hidden sm:block"
          isCollapsed={isConversationHistorySiderCollapsed}
          toggleCollapse={() => setIsConversationHistorySiderCollapsed((prev) => !prev)}
        />
      }
    >
      <div className="flex h-full">
        <MainContent />
        <ReferenceDocuments className="hidden sm:flex" />
      </div>
    </Screen>
  );
};
